import type { ButtonProps } from "@timeghost/ui/shadcn/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@timeghost/ui/shadcn/dropdown-menu";
import { MoreHorizontal } from "lucide-react";
import type { JSX, ReactElement, ReactNode } from "react";

interface ActionsMenuProps {
	readonly align?: "start" | "center" | "end";
	readonly children: ReactNode;
	readonly contentClassName?: string;
	readonly icon?: ReactNode;
	readonly sideOffset?: number;
	readonly trigger: ReactElement<ButtonProps>;
}

export default function ActionsMenu({
	children,
	trigger,
	icon = <MoreHorizontal />,
	align = "end",
	contentClassName,
	sideOffset,
}: ActionsMenuProps): JSX.Element {
	return (
		<DropdownMenu>
			<DropdownMenuTrigger render={trigger}>{icon}</DropdownMenuTrigger>
			<DropdownMenuContent align={align} className={contentClassName} sideOffset={sideOffset}>
				{children}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}

export { DropdownMenuItem, DropdownMenuSeparator } from "@timeghost/ui/shadcn/dropdown-menu";
